import { canv } from '@/canv/global.js'
import { generateUID } from '@/canv/utils.js'

export class elementBase {


    constructor() {
        this.UID = generateUID();
    }


    TryAction(type) {

    }

    // Draw

    draw() { }

    drawOver() { }

    shouldDraw() {
        return this.parent.isGroupOnScreen();
    }


    // helpers

    clearText() {

    }




    // translate, resize

    translate(x, y) { }

    /**
     *
     * @param {number} x delta x
     * @param {number} y delta y
     * @param {string} catchPointer catch pointer
     * @returns {void}
     */
    resize(x, y, catchPointer) { }






    // updateDims

    updateDims(withBaseParent = true) { }

    updateBase(startX, startY, width, height, withBaseParent = true) {
        this.baseStartX = startX;
        this.baseStartY = startY;
        this.baseWidth = width;
        this.baseHeight = height;
        if (withBaseParent && this.parent != null) {
            this.parent.bottomTopUpdateDims();
        }
    }






    // Becoming, Before

    beforeDeletion() { }

    translatingStart() { };

    translatingStop() { };

    rotatingStart() { };

    rotatingStop() { };

    resizingStart() { }
    /**
     * @param {boolean} catchPointer
     * @returns {void}
     * @example
     * resizingStop(true);
     * resizingStop(false);
     */
    resizingStop() { }





    // iss

    isInteraction(context, force = false) {
        /*
            return {
                "type": none | click | interaction;
                // было что-то еще?
            };
        */
        return { "type": "none" };
    }

    shouldStopInteractionOnModeChange(_nextMode) {
        return true;
    }

    stopInteraction() { }

    /**
     *
     * @param {boolean} isCandidate есть ли виджет поверх текущего
     * @returns {boolean}
     */
    isOver(isCandidate = false) {
        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;
        var y = pt.y;

        // Преобразования нужные, чтобы сравниваться с x, y (и не нужны чтобы рисовать в makeSelected)
        var realStartPixX = this.baseStartX * canv.m[0];
        var realStartPixY = this.baseStartY * canv.m[3];
        var realWidth = this.baseWidth * canv.m[0];
        var realHeight = this.baseHeight * canv.m[3];

        if (x >= realStartPixX && x <= realStartPixX + realWidth && y >= realStartPixY && y <= realStartPixY + realHeight) {
            //return true;
        }

        if (x >= this.baseStartX && x <= this.baseStartX + this.baseWidth && y >= this.baseStartY && y <= this.baseStartY + this.baseHeight) {
            return true;
        }


        return false;
    }

    isInArea(area) {

        // для simulated блока : начало левее и выше правого нижнего угла this фигуры, а конец правее и ниже начала this

        if (area["x"] <= this.baseStartX + this.baseWidth && area["y"] <= this.baseStartY + this.baseHeight && area["x"] + area["width"] >= this.baseStartX && area["y"] + area["height"] >= this.baseStartY) {
            return true;
        }

        return false;
    }

    isCatched() {
        return false;
    }

    showCatchPointer() { }




    // Для menu
    /**
     *
     * @param {Boolean} [isLocked] - group.isLocked
     */
    getWidgetOptions(isLocked) { }

    /**
     *
     * @param {string} name
     * @returns {Function | void}
     */
    getHandlerForOption(name) { }

    locateWidgetMenu() {
        return { "status": false };
    }




    // SET PARENT - единственный способ выставлять parentUID (кроме loadState) и аболютно единственны this.parent

    setParent(group, disableRemoving) {
        this.parentUID = group.UID;
        this.parent = group;
        group.children.push(this);
        this.updateBase(this.baseStartX, this.baseStartY, this.baseWidth, this.baseHeight);
    }

    isNeedInit() {
        return false;
    }

    initWidget() { }

    checkDeletion() {
        return true;
    }

    regenerateUIDS() { }

    // Далее для states

    buildProperty(property, fixType, action) { }

    checkEvent(state, fixType) {
        return true;
    }

    getFixType(reason) { }

    getState(fixType, twinState) { }

    loadState(state, fixType) { }



    fixState(reason) {
        const fixType = this.getFixType(reason);
        this.statesMap[reason] = {
            "fixType": fixType,
            "state": this.getState(fixType)
        };
    }

    saveState(reason) {
        if (this.statesMap[reason] == undefined) {
            return;
        }

        const fixType = this.statesMap[reason]["fixType"];

        canv.eventManager.createPropertyEvent(this.UID, fixType, this.statesMap[reason]["state"], this.getState(fixType));
    }

    /**
     * @typedef {object} SearchResult
     * @property {string} mode
     * @property {boolean} status
     * @property {textWidget} textWidget
     */

    /**
     *
     * @param {string} text search text
     * @returns {Array.<SearchResult>}
     */
    searchText(text) {
        return [];
    }

    reset() { }

    becomingFocused() { }

    becomingSelected() { }

    fixedState = "";
    fixType = "";
    unsavedState = false;
    statesMap = {};


    constructorName = "";
    UID = "";
    parentUID = "";
    trailUID = "";
    anchorUID = "";

    baseStartX = 0;
    baseStartY = 0;
    baseWidth = 0;
    baseHeight = 0;

    /**
     * @type {Group | null}
     */
    parent = null;


    rotatable = true;
    isSelected = false;

    customResize = false; // используется для стрелки
    allowSideResize = false; // используется для карточки
    allowOptionsForLocked = false; // для стрелок и фреймов
    fastAction = "classic";

    catchPointer = 0;
    pointerSize = 0;

    disableConnectors = false; // используется, чтобы вокруг стрелок небыло connectors
    disableLevelLines = false; // используется, чтобы стрелки не давали levelLines и чтобы стрелки не магнитились к levelLines
    disableOutline = false; // используется, чтобы не рисовать outline в setSelected, addSelected и cursorTool outline для стрелок
    nothingWhenInteraction = false; // используется, чтобы не рисовать outline, catchPointers... в interaction mode (например table)
    nothingWhenInteractionLowOutline = false; // используется, чтобы рисовать low outline при nothingWhenInteraction (у textWidget)

    widgetOptions = [];

}
